<template>
  <DestinationTheme />
</template>

<script setup lang="ts">
import DestinationTheme from '@/wabunka-src/features/DestinationTheme/pages/DestinationTheme/DestinationTheme.vue';
// 境界線なし・白文字のヘッダー
definePageMeta({ layout: 'en-experience-id', headerBgTransparent: true });
</script>
